import script from "./ListItemAudio.vue?vue&type=script&setup=true&lang=ts"
export * from "./ListItemAudio.vue?vue&type=script&setup=true&lang=ts"

import "./ListItemAudio.vue?vue&type=style&index=0&id=3aa402d4&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3aa402d4"]])

export default __exports__